export const NodeDashboardSharePermission = "NodeDashboardShare";

export const getSetMachineToMachineCredentialsUrl = hubId => `MachineToMachineInteraction/Credentials/?hubId=${hubId}`;
